export const DEFAULT_PAGE_COUNT = 25;

export const DEFAULT_IMAGE = "/favicon.ico";
export const DEFAULT_PROFILE = "/assets/imgs/logo/images.png";
